(() => {
  if (window.ddNavigationInitialized) return;
  window.ddNavigationInitialized = true;
  function closeMenus(except) {
    document.querySelectorAll('.dd-mega-toggle[open]').forEach(menu => { if (menu !== except) menu.open = false; });
  }
  function initialize() {
    document.querySelectorAll('.dd-mega-toggle').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('toggle', () => { if (menu.open) closeMenus(menu); });
      const area = menu.closest('.dd-nav-item') || menu;
      area.addEventListener('focusout', event => { if (!area.contains(event.relatedTarget)) menu.open = false; });
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.dd-mega-toggle[open], .dd-mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.dd-nav-item, .dd-mega-toggle')) closeMenus();
  });
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();

// Reopen Shopify's native consent preferences without replacing its consent storage.
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-dd-cookie-preferences]');
  if (!link || !window.privacyBanner || !window.privacyBanner.showPreferences) return;
  event.preventDefault();
  window.privacyBanner.showPreferences({ locale: document.documentElement.dataset.ddLanguage || document.documentElement.lang }).catch(function () { window.location.href = link.href; });
});

(() => {
  let opener;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-dd-search-open]');
    const dialog = document.getElementById('DDSearchDrawer');
    if (!dialog) return;
    if (trigger) {
      opener = trigger;
      document.querySelectorAll('.dd-mega-toggle[open], .dd-mobile-menu[open]').forEach(menu => menu.open = false);
      dialog.showModal();
      document.documentElement.classList.add('dd-search-is-open');
      dialog.querySelector('input[type=search]').focus();
    } else if (event.target.closest('[data-dd-search-close]')) dialog.close();
    else if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) dialog.close();
    }
  });
  function bindSearch() {
    const dialog = document.getElementById('DDSearchDrawer');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('dd-search-is-open');
      if (opener && opener.isConnected) opener.focus();
    });
  }
  bindSearch();
  document.addEventListener('shopify:section:load', bindSearch);
})();

// Accessible inline validation avoids browser-language tooltips in the search drawer.
function ddShowSearchError(input) {
  const form = input.closest('.dd-search-form');
  if (!form) return;
  form.querySelector('.dd-search-error').hidden = false;
  input.setAttribute('aria-invalid', 'true');
  input.focus();
}
document.addEventListener('invalid', event => {
  if (!event.target.matches('.dd-search-form input[type=search]')) return;
  event.preventDefault();
  ddShowSearchError(event.target);
}, true);
document.addEventListener('submit', event => {
  if (!event.target.matches('.dd-search-form')) return;
  const input = event.target.querySelector('input[type=search]');
  if (!input.value.trim()) { event.preventDefault(); ddShowSearchError(input); }
});
document.addEventListener('input', event => {
  if (!event.target.matches('.dd-search-form input[type=search]')) return;
  event.target.removeAttribute('aria-invalid');
  event.target.closest('form').querySelector('.dd-search-error').hidden = true;
});
